// @flow
import fetchFromApiServer from '../../../service/index';


export function getCartItems(cartUrl,uid){
    var url = 'WMSDetail/GetCartDetail?cartUrl=' + cartUrl; 
    return {
      type:'CART',
      payload:fetchFromApiServer("GET", url)
    }
  }

export function showOrHideDetailOfItem(AdKey,index){
  return {
    type:'SHOW_HIDE_DETAIL',
    AdKey:AdKey,
    index:index
  }
}

export function updateAddToCart(obj){
  var url = 'WMSDetail/UpdateCartList';
  return {
    type:'UPDATE_ADD_TO_CART',
    payload:fetchFromApiServer("POST", url, obj)
  }
}

export function removeItemFromCart(obj){
  var url = 'WMSDetail/RemoveCart';
  return {
    type:'REMOVE_ITEM_FROM_CART',
    payload:fetchFromApiServer("POST", url, obj)
  }
}

export function increaseQuantity(item,index){
  return {
    type:'INCREASE_QUANTITY',
    item:item,
    index:index
  }
}
export function decreaseQuantity(item,index){
  return {
    type:'DECREASE_QUANTITY',
    item:item,
    index:index,
  }
}

export function clearCart(){
  return {
    type:'CLEAR_CART'
  }
}


